"use client";

import { useQuery } from "@tanstack/react-query";
import { useBackend } from "./useBackend";

/**
 * Hook for fetching a single video job with smart polling.
 * Polls every 3 seconds while job is pending or processing,
 * stops polling when job is completed or failed.
 */
export function useVideoJob(id: string | undefined) {
  const backend = useBackend();

  return useQuery({
    queryKey: ["video", id],
    queryFn: () => backend.video.get(id!),
    enabled: !!id,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      // Poll every 3s while active, stop when done
      return status === "pending" || status === "processing" ? 3000 : false;
    },
  });
}
